export enum OverallRadioCheckStatus {
  COMPLETED = 'COMPLETED',
  INCOMPLETE = 'INCOMPLETE',
  FAILED = 'FAILED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  TIMED_OUT = 'TIMED_OUT',
  CANCELED = 'CANCELED',
}

export enum DeviceRadioCheckStatus {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  CRITICAL = 'CRITICAL',
  TIMED_OUT = 'TIMED_OUT',
  PENDING = 'PENDING',
}

export const RSSI_THRESHOLD = -105;
export const SNR_THRESHOLD = -8;
export const SF_THRESHOLD = 8;
